export class UsageData {
    activeCompanies: number;
    inactiveCompanies: number;
}
